import { render, staticRenderFns } from "./pnrInput.vue?vue&type=template&id=52b56327&scoped=true&"
import script from "./pnrInput.vue?vue&type=script&lang=js&"
export * from "./pnrInput.vue?vue&type=script&lang=js&"
import style0 from "./pnrInput.vue?vue&type=style&index=0&id=52b56327&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b56327",
  null
  
)

export default component.exports